import { render, staticRenderFns } from "./AgendaViewSchedule.vue?vue&type=template&id=72f5986c&scoped=true&"
import script from "./AgendaViewSchedule.vue?vue&type=script&lang=js&"
export * from "./AgendaViewSchedule.vue?vue&type=script&lang=js&"
import style0 from "./AgendaViewSchedule.vue?vue&type=style&index=0&id=72f5986c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f5986c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDivider,VRow})
